module.exports = __webpack_public_path__ + "static/media/stjones_antigua.da30e2c2.jpg";